export default __webpack_public_path__ + "static/media/logoPink.39134cd6.svg";